// Smooth inertia scrolling (Lenis) — in Shopify this init lives in theme.liquid.
// Cart drawer / modals get data-lenis-prevent so they scroll natively.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var lenis = new Lenis({
    lerp: 0.14,          // smoothing: 0.05 = dreamy float ... 0.2 = near-native (was 0.09)
    wheelMultiplier: 1,  // scroll distance per wheel tick
    smoothWheel: true    // inertia on mouse wheel / trackpad
  });
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  document.querySelectorAll('cart-drawer, dialog, [data-cart-drawer]').forEach(function (el) {
    el.setAttribute('data-lenis-prevent', '');
  });
})();


// Sticky header — transforms into a dark lozenge once the page scrolls.
// Mobile: the scrolled lozenge collapses to shield + burger; burger toggles the page list.
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var burger = header.querySelector('.header-burger');
  var menu = header.querySelector('.mobile-menu');
  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    if (burger) {
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
    }
  }
  function update() {
    var scrolled = window.scrollY > 40;
    header.classList.toggle('is-scrolled', scrolled);
    if (!scrolled) closeMenu();
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  }
})();


// Preloader (black bg, white shield fades in, flips back, bg fades out)
// + hero entrance: headline letter stagger, copy line blinds, button fades.
// Full loader plays once per session; repeat visits go straight to the entrance.
(function () {
  var preloader = document.getElementById('preloader');
  var hero = document.querySelector('.hero');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Loader plays on first landing and on hard reloads; in-site navigation
  // (Home/logo clicks, back button) skips straight to the hero entrance.
  var seen = false;
  try {
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var gated = !!sessionStorage.getItem('av-intro');
    sessionStorage.setItem('av-intro', '1');
    seen = gated && nav.type !== 'reload';
  } catch (e) {}

  // --- split headline into letter spans ---
  function splitLetters(el, baseDelay, step) {
    var text = el.textContent;
    el.textContent = '';
    var i = 0;
    text.split(' ').forEach(function (word, w, arr) {
      var wordEl = document.createElement('span');
      wordEl.className = 'word';
      word.split('').forEach(function (ch) {
        var s = document.createElement('span');
        s.className = 'char';
        s.textContent = ch;
        s.style.setProperty('--d', (baseDelay + i * step) + 's');
        wordEl.appendChild(s);
        i++;
      });
      el.appendChild(wordEl);
      if (w < arr.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  // --- group copy words into measured lines, wrap for blinds ---
  function splitLines(el, baseDelay, step) {
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    var spans = words.map(function (word) {
      var s = document.createElement('span');
      s.textContent = word;
      s.style.whiteSpace = 'nowrap'; // keep hyphenated words (anti-fog) on one line
      el.appendChild(s);
      el.appendChild(document.createTextNode(' ')); // breakable space between words
      return s;
    });
    var lines = [];
    spans.forEach(function (s) {
      var top = s.offsetTop;
      var line = lines[lines.length - 1];
      if (!line || line.top !== top) { line = { top: top, words: [] }; lines.push(line); }
      line.words.push(s.textContent + ' ');
    });
    el.textContent = '';
    lines.forEach(function (line, idx) {
      var outer = document.createElement('span');
      outer.className = 'line';
      var inner = document.createElement('span');
      inner.textContent = line.words.join('');
      inner.style.whiteSpace = 'nowrap';
      inner.style.setProperty('--d', (baseDelay + idx * step) + 's');
      outer.appendChild(inner);
      el.appendChild(outer);
    });
  }

  function setup() {
    if (!hero) return;
    splitLetters(hero.querySelector('.hero-title .t-display'), 0, 0.035);
    splitLetters(hero.querySelector('.hero-title .t-serif'), 0.45, 0.035);
    var copy = hero.querySelector('.hero-copy');
    if (copy) splitLines(copy, 0.7, 0.12);
    hero.querySelectorAll('.hero-ctas .btn-cut').forEach(function (btn, i) {
      btn.style.setProperty('--d', (1.0 + i * 0.15) + 's');
    });
  }

  function enter() { if (hero) hero.classList.add('is-entered'); }
  function killPreloader() { if (preloader && preloader.parentNode) preloader.parentNode.removeChild(preloader); }

  if (reduced) {
    killPreloader();
    if (hero) { hero.classList.add('is-entered'); }
    document.querySelectorAll('.hero .char, .hero-copy, .hero-ctas .btn-cut').forEach(function (el) {
      el.style.transition = 'none';
    });
    return;
  }

  document.fonts.ready.then(function () {
    setup();
    if (seen || !preloader || !window.gsap) {
      // repeat visit (or GSAP missing) — skip the loader, play the entrance
      killPreloader();
      setTimeout(enter, 60);
      return;
    }
    // first visit — GSAP timeline (Suba-style choreography):
    // shield fades up, holds, flips back on a 3D plane, curtain fades close behind
    var shield = preloader.querySelector('.pl-shield');

    // paint the shield white via canvas — CSS filter:invert() flattens 3D in Safari
    function whiten() {
      try {
        var c = document.createElement('canvas');
        c.width = shield.naturalWidth; c.height = shield.naturalHeight;
        var x = c.getContext('2d');
        x.drawImage(shield, 0, 0);
        x.globalCompositeOperation = 'source-in';
        x.fillStyle = '#FFFFFF';
        x.fillRect(0, 0, c.width, c.height);
        shield.src = c.toDataURL();
      } catch (e) {}
    }
    if (shield.complete) whiten(); else shield.addEventListener('load', whiten, { once: true });

    gsap.set(shield, { transformPerspective: 500, transformOrigin: '50% 50%', y: 14, opacity: 0 });
    gsap.timeline()
      .to(shield, { opacity: 1, y: 0, duration: 0.55, ease: 'power3.out' }, 0.15)
      /* exit: fly up + slight backward rotation out (Suba logoOut energy) */
      .to(shield, { y: -160, rotationX: 55, z: -50, duration: 0.7, ease: 'power3.in' }, 1.05)
      .to(shield, { opacity: 0, duration: 0.3, ease: 'power1.in' }, 1.35)
      .add(enter, 1.45)
      .to(preloader, { autoAlpha: 0, duration: 0.6, ease: 'power2.inOut', onComplete: killPreloader }, 1.45);
  });
})();


// Shared image crossfade: a ghost <img> fades in over the main image, then the main takes over.
window.avCrossfade = function (main, ghost, src, isPhoto, pos, onDone) {
  var pre = new Image();
  var wasPhoto = main.classList.contains('is-photo');
  pre.onload = function () {
    if (!isPhoto && !wasPhoto) {
      // cut-out to cut-out: a crossfade overlaps two transparent packshots, so fade through instead
      main.style.opacity = 0;
      setTimeout(function () {
        main.src = src; main.style.objectPosition = '';
        void main.offsetWidth; main.style.opacity = 1;
        if (onDone) onDone();
      }, 260);
      return;
    }
    ghost.src = src;
    ghost.classList.toggle('is-photo', !!isPhoto);
    ghost.style.objectPosition = (isPhoto && pos) ? pos : '';
    void ghost.offsetWidth;                 // commit before fading
    ghost.style.opacity = 1;
    setTimeout(function () {
      main.src = src;
      main.classList.toggle('is-photo', !!isPhoto);
      main.style.objectPosition = (isPhoto && pos) ? pos : '';
      ghost.style.transition = 'none'; ghost.style.opacity = 0;
      void ghost.offsetWidth; ghost.style.transition = '';
      if (onDone) onDone();
    }, 520);
  };
  pre.src = src;
};

// Product-tile mini gallery — thumb squares swap the main image.
// Thumbs live inside the card <a>, so clicks must not navigate.
(function () {
  document.querySelectorAll('.card-img').forEach(function (box) {
    var main = box.querySelector('.ci-main');
    if (!main) return;
    var ghost = document.createElement('img');
    ghost.className = 'ci-main ci-ghost'; ghost.alt = ''; ghost.setAttribute('aria-hidden', 'true');
    main.insertAdjacentElement('afterend', ghost);
    box.querySelectorAll('.ci-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (thumb.classList.contains('is-active')) return;
        box.querySelectorAll('.ci-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var isPhoto = thumb.dataset.type === 'photo';
        box.classList.toggle('is-photo', isPhoto);
        window.avCrossfade(main, ghost, thumb.dataset.src, isPhoto, '', null);
      });
    });
  });
})();


// Home colour switcher — in Shopify this becomes the variant picker
// on a featured-product section (Horizon handles it natively).
(function () {
  var card = document.getElementById('option-single');
  if (!card) return;

  var VARIANTS = {
    clear: { img: 'assets/img/product-clear.png', title: 'CLEAR', frame: 'CLEAR FRAME', href: 'product-clear.html', cta: 'Shop Clear' },
    black: { img: 'assets/img/product-black.png', title: 'BLACK', frame: 'BLACK FRAME', href: 'product-black.html', cta: 'Shop Black' }
  };

  try {
    var vd = document.getElementById('av-variant-data');
    if (vd) VARIANTS = JSON.parse(vd.textContent);
  } catch (e) {}

  // preload both packshots so switching is instant
  Object.keys(VARIANTS).forEach(function (k) { new Image().src = VARIANTS[k].img; });

  var img = document.getElementById('os-img');
  var title = document.getElementById('os-title');
  var frame = document.getElementById('os-frame');
  var link = document.getElementById('os-link');
  var linkLabel = link.querySelector('span') || link;
  var media = document.getElementById('os-media');
  var thumbs = document.getElementById('os-thumbs');

  // supporting-image column: click swaps the main image; photos render edge-to-edge
  var ghost = document.createElement('img');
  ghost.className = 'os-ghost'; ghost.alt = ''; ghost.setAttribute('aria-hidden', 'true');
  img.insertAdjacentElement('afterend', ghost);
  function showMedia(src, type, pos) {
    var isPhoto = type === 'photo';
    if (media) media.classList.toggle('is-photo', isPhoto);
    window.avCrossfade(img, ghost, src, isPhoto, pos, null);
  }
  function bindThumbs() {
    if (!thumbs) return;
    thumbs.querySelectorAll('.os-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.querySelectorAll('.os-thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        showMedia(t.dataset.src, t.dataset.type, t.dataset.pos);
      });
    });
  }
  function renderThumbs(list) {
    if (!thumbs) return;
    thumbs.innerHTML = '';
    (list || []).forEach(function (m, i) {
      var b = document.createElement('button');
      b.className = 'os-thumb' + (i === 0 ? ' is-active' : '');
      b.dataset.src = m.src; b.dataset.type = m.type; b.dataset.pos = m.pos || '';
      b.innerHTML = '<img src="' + m.thumb + '" alt="" loading="lazy">';
      thumbs.appendChild(b);
    });
    bindThumbs();
  }
  bindThumbs();

  card.querySelectorAll('.swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = VARIANTS[btn.dataset.variant];
      if (!v || btn.classList.contains('is-active')) return;
      card.querySelectorAll('.swatch').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      img.alt = 'ARMOUR VIEW ' + v.title;
      window.avCrossfade(img, ghost, v.img, false, '', null);
      title.textContent = v.title;
      if (frame) frame.textContent = v.frame;
      link.href = v.href;
      linkLabel.textContent = v.cta;
      if (media) media.classList.remove('is-photo');
      img.style.objectPosition = '';
      renderThumbs(v.media);
    });
  });
})();


// Live cart count — Horizon dispatches 'cart:update' after AJAX cart changes,
// but its detail only carries the delta from product forms, so re-read /cart.js.
(function () {
  function setCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }
  document.addEventListener('cart:update', function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  });
})();


// Policy pages (/policies/*): Shopify renders a flat .rte; group it into visor boxes.
(function () {
  var rte = document.querySelector('.shopify-policy__body .rte');
  if (!rte) return;
  var nodes = Array.prototype.slice.call(rte.childNodes).filter(function (n) { return n.nodeType === 1; });
  var hasH2 = nodes.some(function (n) { return n.tagName === 'H2'; });
  var boxes = [], cur = null;
  function open() { cur = document.createElement('div'); cur.className = 'policy-box visor'; boxes.push(cur); }
  nodes.forEach(function (n) {
    var starts = hasH2 ? n.tagName === 'H2' : n.tagName === 'P';
    if (starts || !cur) open();
    cur.appendChild(n);
  });
  rte.innerHTML = '';
  boxes.forEach(function (b) {
    var t = document.createElement('span'); t.className = 'v-notch v-notch--top';
    var bt = document.createElement('span'); bt.className = 'v-notch v-notch--bottom';
    b.insertBefore(t, b.firstChild); b.appendChild(bt);
    rte.appendChild(b);
  });
  rte.classList.add('is-boxed');
})();


// Editorial dissolve: start the crossfade only once the section is on screen.
(function () {
  var el = document.querySelector('.editorial-slides');
  if (!el) return;
  if (!('IntersectionObserver' in window)) { el.classList.add('is-inview'); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { el.classList.add('is-inview'); io.disconnect(); } });
  }, { threshold: 0.35 });
  io.observe(el);
})();
